import React from "react"
import * as models from "../models/index"
import { DonutMathResponse } from "../models/donuts"
import DonutChart from "./DonutChart"
import DivisionIcon from "./DonutIcons/Division"

export default class DivisionDonut extends React.Component<{
  studentID?: string
  onLoaded?: (donutsResponse: DonutMathResponse) => void
  refresh?: boolean
}, {
  donutData: DonutMathResponse
  loading: boolean
}> {
  state = {
    loading: true,
    donutData: null
  }

  componentDidMount() {
    this.loadDonuts()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.refresh && this.props.refresh) {
      this.loadDonuts()
    }
  }

  loadDonuts = async () => {
    const donutData = await models.donuts.getMathProgress({
      studentID: this.props.studentID
    })

    if (donutData.valid) {
      this.setState({donutData, loading: false}, ()=>{
        if (this.props.onLoaded) {
          this.props.onLoaded(donutData)
        }
      })
    }
  }

  render() {

    if (this.state.loading) {
        return <></>
    }

    var { division } = this.state?.donutData
    return (
      <div className="text-center">
        <DonutChart
          label="Division"
          total={division.total}
          completed={division.completed}
          baseColor={"#DF554B"}
          Icon={DivisionIcon}
        />
    </div>
    )
  }
}
